<template>
  <div>
    <el-popover
    placement="top-start"
    title="设备信息"
    width="200"
    trigger="hover">
    <div>
      <div v-if="(message.state == null || message.state == '') && (message.devId == null || message.devId == '')">{{ '设备名：'+message.devName }}</div>
      <div v-if="message.devId">{{ '设备ID：'+message.devId }}</div>
      <div v-if="message.state">状态: <span :style="{color:message.color}">{{ message.txt =='在线' && !!!message.devId ?'未安装':message.txt }}</span></div>
    </div>
    <div slot="reference">
      <svg width="35px" height="30px" viewBox="0 0 35 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>编组 52</title>
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
              <g id="编组-52" transform="translate(1.000000, 1.000000)" :fill="backColor" :stroke="borderColor">
                  <line x1="24.75" y1="3.72893873" x2="27.9230769" y2="3.72893873" id="路径备份-65" transform="translate(26.336538, 3.728939) scale(1, -1) translate(-26.336538, -3.728939) "></line>
                  <rect id="矩形备份-50" transform="translate(16.500000, 3.728939) scale(1, -1) translate(-16.500000, -3.728939) " x="0" y="0" width="33" height="7.45787746" rx="3.72893873"></rect>
                  <path d="M11.5567369,7.45787746 L21.4432631,7.45787746 C22.7070792,7.45787746 23.847391,8.21650581 24.3357122,9.38217024 L26.6538462,14.9157549 L26.6538462,14.9157549 L6.34615385,14.9157549 L8.66428784,9.38217024 C9.15260897,8.21650581 10.2929208,7.45787746 11.5567369,7.45787746 Z" id="矩形备份-59" transform="translate(16.500000, 11.186816) scale(1, -1) translate(-16.500000, -11.186816) "></path>
                  <path d="M8.7380737,18.6776532 C9.11702243,19.8637892 8.74174156,21.1613325 7.78814288,21.9620636 L6.2402474,23.2618222 C4.82765269,24.4479695 4.64408081,26.5546662 5.83022812,27.9672609 C5.83944181,27.9782336 5.84872601,27.9891468 5.85808014,28 L5.85808014,28 L5.85808014,28" id="路径-4备份-20"></path>
                  <path d="M16.9880737,18.6776532 C17.3670224,19.8637892 16.9917416,21.1613325 16.0381429,21.9620636 L14.4902474,23.2618222 C13.0776527,24.4479695 12.8940808,26.5546662 14.0802281,27.9672609 C14.0894418,27.9782336 14.098726,27.9891468 14.1080801,28 L14.1080801,28 L14.1080801,28" id="路径-4备份-21"></path>
                  <path d="M25.2380737,18.6776532 C25.6170224,19.8637892 25.2417416,21.1613325 24.2881429,21.9620636 L22.7402474,23.2618222 C21.3276527,24.4479695 21.1440808,26.5546662 22.3302281,27.9672609 C22.3394418,27.9782336 22.348726,27.9891468 22.3580801,28 L22.3580801,28 L22.3580801,28" id="路径-4备份-22"></path>
              </g>
          </g>
      </svg>
    </div>
  </el-popover>
  </div>
</template>

<script>
export default {
  inject:['getNode'],
  data() {
    return {
      borderColor: '#979797',          // 边框颜色
      backColor: 'transparent',        // 背景颜色
      openPolice: false,               // 开启报警
      openOnLine: false,               // 是否在线
      openOffLine:false,               // 是否离线
      polineColor: 'red',              // 报警颜色
      onLineColor: 'green',            // 在线颜色
      offLineColor: '#979797',         // 离线颜色
      interArr:[],
      defaultColor:'#979797',
      message:{
        devName:'烟感',
        state:false,
        color:'#979797',
        txt:'',
        devId:''
      },                  // 设备信息
    };
  },
  mounted(){
    const node = this.getNode();
    node.on('change:data',(res)=>{
      console.log("svg",res)
      let {current}  = res;
      if(current.svgData.borderColor != '')
        this.borderColor = current.svgData.borderColor;
      if(current.svgData.backColor != '')
        this.backColor = current.svgData.backColor;
      if(current.svgData.openPolice){
        let ms = 0;
        this.borderColor = current.svgData.polineColor||this.polineColor;
        let interCode = setInterval(()=>{
          if(ms % 2 != 0){
            this.borderColor = current.svgData.polineColor||this.polineColor;
          }else{
            this.borderColor = this.onLineColor;
          }
          ms++;
        },1000)
        this.interArr.push(interCode);
      }
      if(current.svgData.openOnLine){
        this.borderColor = current.svgData.onLineColor || this.onLineColor;
        // this.borderColor = this.defaultColor;
      }
      if(current.svgData.openOffLine){
        this.borderColor = current.svgData.offLineColor || this.offLineColor;
        // this.borderColor = current.svgData.offLineColor;
      }

      // 设置状态   openPolice: false, // 开启报警 openOnLine: false, // 是否在线openOffLine:false, // 是否离线
      this.message = this.message || {devName:current.svgData.devName || '烟感'}
      this.message.devId = current.svgData.devId
      this.message.state = true;
      this.message.txt =  current.svgData.openPolice?'报警': current.svgData.openOnLine?'在线':'离线';
      this.message.color =  current.svgData.openPolice?current.svgData.polineColor|| current.svgData.polineColor:this.openOnLine?current.svgData.onLineColor || this.onLineColor:current.svgData.onLineColor || this.onLineColor;
    })
  },
  beforeDestroy(){
    this.interArr.forEach(item=>{
      clearTimeout(item);
    })
  }
}
</script>


<style>
</style>